import { buildQueryParams } from "@/utils/build-query-params";
import { httpClient } from "./httpClient";
import { PageResponse } from "@/types/http.type";
import {
  ProcessamentoIADTO,
  ProcessamentoIAEstatisticasDTO,
  ProcessamentoIAResumoDTO,
} from "@/types/processamento-ia.type";
import { ProcessamentoIACriteria, ProcessamentoIAOptions } from "@workflow/types";

class ProcessamentoIAService {
  private readonly basePath = "/api/v1/processamento-ia";

  public async resumo() {
    return await httpClient.get<ProcessamentoIAResumoDTO>(`${this.basePath}/resumo`);
  }

  public async getFiltros() {
    return await httpClient.get<ProcessamentoIAOptions>(`${this.basePath}/filtros`);
  }

  public async estatisticas() {
    return await httpClient.get<ProcessamentoIAEstatisticasDTO>(`${this.basePath}/estatisticas`);
  }

  public async getById(id: number) {
    return await httpClient.get<ProcessamentoIADTO>(`${this.basePath}/${id}`);
  }

  public async list(filter?: ProcessamentoIACriteria) {
    let url = `${this.basePath}`;

    if (filter) {
      const query = buildQueryParams(filter);
      if (query) url += "?" + query;
    }

    return await httpClient.get<PageResponse<ProcessamentoIADTO>>(url);
  }

  public async reprocessar(id: number) {
    return await httpClient.post<ProcessamentoIADTO>(`${this.basePath}/${id}/reprocessar`);
  }

  public async reprocessarLote(ids: number[]) {
    return await httpClient.post<ReprocessamentoLoteResultado>(
      `${this.basePath}/reprocessar-lote`,
      { ids },
    );
  }
}

export interface ReprocessamentoLoteResultado {
  total: number;
  reprocessados: number[];
  falhas: { id: number; motivo: string }[];
}

export const processamentoIAService = new ProcessamentoIAService();
